export default function () {
    return {
        allUnits: [],
    };
}
